export const truncateText = (text: string, length = 16) => {
  if (text.length <= length) return text;

  return `${text.slice(0, length)}\u2026`;
};
